import { categories } from '@/ticket/util/category';
import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import {
  Control,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

interface TicketCategoryDropdownProps<Values extends FieldValues>
  extends UseControllerProps<Values> {
  control: Control<Values>;
}

export function TicketCategoryDropdown<Values extends FieldValues>(
  props: TicketCategoryDropdownProps<Values>
) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control,
  });
  return (
    <FormControl error={!!fieldState.error}>
      <Select
        {...field}
        {...props}
        placeholder={'Select category'}
        size="small"
      >
        {Object.entries(categories).map(([id, options]) => (
          <MenuItem key={id} value={id}>
            {options.label}
          </MenuItem>
        ))}
      </Select>
      {fieldState.error && (
        <FormHelperText>
          {fieldState.error ? fieldState.error.message : 'An error occurred'}
        </FormHelperText>
      )}
    </FormControl>
  );
}
